module.exports = __webpack_public_path__ + "img/image-02.3afc133d.svg";